import { takeLatest, call, put } from 'redux-saga/effects';
import { getPayPal, sendPayPal } from 'api';

import { registrationDone } from 'pages/Login/actions';
import { showLoadScreen, hideLoadScreen } from 'components/LoadScreen/actions';

import * as actions from './actions';

function* sendHandl(action) {
  const { payload: { cb } } = action;
  try {
    const result = yield call(getPayPal);
    if (cb) cb(result.data.clientToken);
  } catch (err) {
    console.log(err);
  }
}

function* sendPayPalHandl(action) {
  const { payload: { cb, card } } = action;

  try {
    yield put(showLoadScreen());
    const result = yield call(sendPayPal, 'fake-valid-nonce', card);
    yield put(registrationDone());
    if (cb) cb(result.data.success_transaction_response);

    yield put(hideLoadScreen());
    // console.log(result);
  } catch (err) {
    console.log(err);
    yield put(hideLoadScreen());
  }
}

export default function* () {
  yield takeLatest(
    actions.GET_PAYPAL,
    sendHandl
  );
  yield takeLatest(
    actions.SENT_PAYPAL,
    sendPayPalHandl
  );
}



// WEBPACK FOOTER //
// ./src/pages/Payment/saga.js